import React, { useState, useEffect } from "react";
import "./Header.scss";
import "./CommonHeaderElements.scss";
import CommonHeaderElements from "./CommonHeaderElements";

const Header: React.FC = () => {
  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    isMobile: window.innerWidth < 768
  });

  // Track viewport size for responsive design
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setViewport({
        width,
        isMobile: width < 768
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className="header" role="banner">
      <div className={`header-container${viewport.isMobile ? " header-container-mobile" : ""}`}>
        <CommonHeaderElements />
      </div>
    </header>
  );
};

export default Header;